import { AlertTriangle } from 'lucide-react';

export default function Disclaimer() {
  return (
    <div data-testid="disclaimer-page" className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-gradient-to-br from-meritum-navy via-meritum-teal to-meritum-teal">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl text-center">
          <span className="inline-block px-4 py-2 bg-white/10 border border-white/20 rounded-sm text-meritum-gold font-body text-sm font-medium mb-6">
            Legal
          </span>
          <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight leading-none text-white mb-4">
            Disclaimer
          </h1>
          <p className="font-body text-base text-slate-200 max-w-2xl mx-auto">
            Please read this disclaimer carefully before using the MeritumPraxis platform.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="prose prose-slate max-w-none">
            {/* Important Notice */}
            <div className="bg-meritum-gold/10 border-l-4 border-meritum-gold p-6 rounded-r-lg mb-12">
              <div className="flex items-start gap-4">
                <AlertTriangle className="text-meritum-gold flex-shrink-0 mt-1" size={24} />
                <div>
                  <h2 className="font-heading text-xl font-semibold text-meritum-navy mt-0 mb-2">
                    Important Notice
                  </h2>
                  <p className="font-body text-slate-600 mb-0">
                    MeritumPraxis is not a recruitment agency.
                  </p>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="space-y-8">
              <div>
                <h2 className="font-heading text-2xl font-semibold text-meritum-navy mb-4">
                  What MeritumPraxis Does Not Do
                </h2>
                <p className="font-body text-slate-600 leading-relaxed mb-4">
                  The platform does not:
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <span className="w-2 h-2 mt-2 bg-meritum-teal rounded-full flex-shrink-0" />
                    <span className="font-body text-slate-600">Recruit candidates on behalf of organizations</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-2 h-2 mt-2 bg-meritum-teal rounded-full flex-shrink-0" />
                    <span className="font-body text-slate-600">Negotiate employment terms</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-2 h-2 mt-2 bg-meritum-teal rounded-full flex-shrink-0" />
                    <span className="font-body text-slate-600">Represent candidates in hiring discussions</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-2 h-2 mt-2 bg-meritum-teal rounded-full flex-shrink-0" />
                    <span className="font-body text-slate-600">Guarantee employment opportunities</span>
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-meritum-navy mb-4">
                  Platform Purpose
                </h2>
                <p className="font-body text-slate-600 leading-relaxed">
                  MeritumPraxis only provides a platform that enables professional visibility and discovery. 
                  The platform facilitates connections between candidates and organizations but does not 
                  participate in or influence employment decisions, negotiations, or outcomes.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-meritum-navy mb-4">
                  Governing Law
                </h2>
                <p className="font-body text-slate-600 leading-relaxed">
                  This disclaimer and your use of the MeritumPraxis platform shall be governed by and 
                  construed in accordance with the laws of the Republic of South Africa. Any disputes 
                  arising from the use of this platform shall be subject to the exclusive jurisdiction 
                  of the courts of the Republic of South Africa.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-meritum-navy mb-4">
                  Limitation of Liability
                </h2>
                <p className="font-body text-slate-600 leading-relaxed">
                  MeritumPraxis (Pty) Ltd shall not be liable for any direct, indirect, incidental, 
                  consequential, or punitive damages arising from the use of this platform, including 
                  but not limited to employment outcomes, business decisions, or any interactions 
                  facilitated through the platform.
                </p>
              </div>
            </div>

            {/* Last Updated */}
            <div className="mt-12 pt-8 border-t border-slate-200">
              <p className="font-body text-sm text-slate-500">
                <strong>Effective Date:</strong> February 2026<br />
                <strong>Company:</strong> MeritumPraxis (Pty) Ltd<br />
                <strong>Jurisdiction:</strong> Republic of South Africa
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
